import React, { Component } from 'react';
import { dispatch, IRootDispatch, IRootState, state } from '../../../../stores/rematch/root-store';
import { TransportAttendanceType } from '../../../../utilities/enum-utils';
import { connect } from 'react-redux';
import ActionModal, { ActionModalFooter } from '../../../../common-components/modal/ActionModal';
import { Paragraph } from '../../../../common-components/typography';
import { GhostButton, PrimaryButton } from '../../../../common-components/buttons';
import { notification } from 'antd';

interface IChangeTransportBookingToBusinessCancelModalProps {
  isOpen: boolean;
  onClose: () => void;
  transportBooking: any;
  doChangeTransportBookingToBusinessCancel: typeof dispatch.groupBookingsStore.doChangeTransportBookingToBusinessCancel;
  selectedGroupBookingItem: typeof state.groupBookingsStore.selectedGroupBookingItem;
  attendanceType: TransportAttendanceType;
}

interface IChangeTransportBookingToBusinessCancelModalState {
  step: number;
  title: string;
  canManuallyClose: boolean;
}

class ChangeTransportBookingToBusinessCancelModal extends Component<
  IChangeTransportBookingToBusinessCancelModalProps,
  IChangeTransportBookingToBusinessCancelModalState
> {
  state = {
    step: 1,
    title: 'Change to cancelled by business',
    canManuallyClose: true,
  };

  onCloseModal = () => {
    const { onClose } = this.props;
    this.setState({ step: 1, canManuallyClose: true, title: 'Change to cancelled by business' }, onClose);
  };

  onSubmit = async () => {
    const { transportBooking, selectedGroupBookingItem, attendanceType } = this.props;
    try {
      this.setState({ canManuallyClose: false });
      await this.props.doChangeTransportBookingToBusinessCancel({
        bookingId: selectedGroupBookingItem.bookingId,
        transportBookingId: transportBooking.attendanceId,
        attendanceType,
      });
      this.setState({ step: 2, canManuallyClose: true, title: 'Booking status changed' });
    } catch (e) {
      this.setState({ canManuallyClose: true });
      notification.error({ message: 'Oops, something went wrong, please try again.' });
    }
  };

  renderView = () => {
    const { step } = this.state;
    if (step === 1) {
      return (
        <div className="anim-fade-in">
          <Paragraph>Are you sure you want to change the status of the booking to Cancelled by the business?</Paragraph>
          <ActionModalFooter>
            <GhostButton className="mr-medium" size="large" onClick={this.onCloseModal}>
              Cancel
            </GhostButton>
            <PrimaryButton size="large" icon="check" onClick={this.onSubmit}>
              Change to Business cancelled
            </PrimaryButton>
          </ActionModalFooter>
        </div>
      );
    }

    if (step === 2) {
      return (
        <div className="anim-slide-right">
          <Paragraph>You have successfully changed the status of this booking to Business cancelled</Paragraph>

          <ActionModalFooter>
            <PrimaryButton size="large" onClick={this.onCloseModal}>
              Close
            </PrimaryButton>
          </ActionModalFooter>
        </div>
      );
    }
  };

  render() {
    let { isOpen } = this.props;
    const { title } = this.state;
    return (
      <ActionModal
        isOpen={isOpen}
        title={title}
        width="medium"
        onClose={this.onCloseModal}
        canCloseOutside={this.state.canManuallyClose}
        showCloseButton={this.state.canManuallyClose}
        verticalAlignment="highest"
      >
        <div>{this.renderView()}</div>
      </ActionModal>
    );
  }
}

const mapState = (state: IRootState) => ({
  selectedGroupBookingItem: state.groupBookingsStore.selectedGroupBookingItem,
});

const mapDispatch = (dispatch: IRootDispatch) => ({
  doChangeTransportBookingToBusinessCancel: dispatch.groupBookingsStore.doChangeTransportBookingToBusinessCancel,
});

export default connect(mapState, mapDispatch)(ChangeTransportBookingToBusinessCancelModal);
